import axios from "axios";
import { createEvent } from "../features/analytics";

const noAuthAxios = axios.create();
noAuthAxios.interceptors.response.use(response => {
    return response;
 }, error => {
    console.log({error});
   if (error.response.status === 401) {
    // TODO
    throw error;
   }
   return error;
 });
const authAxios = axios.create();
authAxios.interceptors.request.use(config => {
    const token = localStorage.token;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
})

const copy = input => JSON.parse(JSON.stringify(input));

export const duplicateClass = (id, payload) => {
    return async (dispatch) => {
        try {
            const c = await authAxios.post(`/api/class/duplicate/${id}`, payload);
            dispatch({
                type: "ADD_CLASS",
                class: c.data
            })
        } catch (error) {
            
        }
    }
}

export const getSchools = () => {

    return dispatch => {
        noAuthAxios.get('/school')
            .then(response => {
                dispatch({
                    type: "GET_SCHOOLS",
                    schools: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSchool = (schoolId) => {
    return dispatch => {
        noAuthAxios.get(`/school/${schoolId}`)
            .then(response => {
                dispatch({
                    type: "SET_SCHOOL",
                    school: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClasses = () => {
    return dispatch => {
        noAuthAxios.get("/school/class")
            .then(response => {
                dispatch({
                    type: "GET_CLASSES",
                    classes: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getPossibleClasses = (schoolId) => {
    return dispatch => {
        noAuthAxios.get(`/school/class/${schoolId}`)
            .then(response => {
                dispatch({
                    type: "GET_POSSIBLE_CLASSES",
                    possibleClasses: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}


export const fetchServerTime = () => {
    return dispatch => {
         noAuthAxios.get("/api/v2/server-time/now")
         .then(response => {
            dispatch({
                type: "GET_SERVER_TIME",
                serverTimeAsUtcISO: response.data.serverTimeAsUtcISO
            });
        })
        .catch(error => {
            dispatch({
                type: "ERROR",
                error: error.response.statusText
            });
        });
    }
}

export const getFeedback = () => {
    return dispatch => {
        authAxios.get("/feedback")
            .then(response => {
                dispatch({
                    type: "GET_FEEDBACK",
                    feedback: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}


export const getRequests = () => {
    return dispatch => {
        authAxios.get("/request")
            .then(response => {
                dispatch({
                    type: "GET_REQUESTS",
                    requests: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getReview = (studentId, assignmentId) => {
    return dispatch => {
        authAxios.get(`/api/review/${studentId}/${assignmentId}`)
            .then(response => {
                dispatch({
                    type: "SET_REVIEW",
                    review: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const setTask = (task) => {
    return dispatch => {
        dispatch({
            type: "SET_TASK",
            task
        });
    }
}

export const setReview = (review) => {
    return dispatch => {
        dispatch({
            type: "SET_REVIEW",
            review
        });
    }
}

export const setClassIndex = (classIndex) => {
    return dispatch => {
        dispatch({
            type: "SET_CLASS_INDEX",
            classIndex
        });
    }
}

export const setEvaluation = (evaluation) => {
    return dispatch => {
        dispatch({
            type: "SET_EVALUATION",
            evaluation
        });
    }
}

export const setTeacherAssignments = (assignments) => {
    return dispatch => {
        dispatch({
            type: "SET_TEACHER_ASSIGNMENTS",
            assignments
        });
    }
}

export const setClassAssignments = (assignments) => {
    return dispatch => {
        dispatch({
            type: "SET_CLASS_ASSIGNMENTS",
            assignments
        });
    }
}

export const setAssignment = (assignment) => {
    return dispatch => {
        dispatch({
            type: "SET_ASSIGNMENT",
            assignment
        });
    }
}

export const setSprint = (sprint) => {
    return dispatch => {
        dispatch({
            type: "SET_SPRINT",
            sprint
        });
    }
}

export const setSprints = (sprints) => {
    return dispatch => {
        dispatch({
            type: "SET_SPRINTS",
            sprint
        });
    }
}

export const setClass = (classObject) => {
    return dispatch => {
        dispatch({
            type: "SET_CLASS",
            classObject
        });
    }
}

export const setStudent = (student) => {
    return dispatch => {
        dispatch({
            type: "SET_STUDENT",
            student
        });
    }
}

export const setSchool = (school) => {
    return dispatch => {
        dispatch({
            type: "SET_SCHOOL",
            school
        });
    }
}

export const resetEvaluationStatus = () => {
    return dispatch => {
        dispatch({
            type: "RESET_ERROR_STATUS"
        });
    }
}

export const setEvaluationSprintAndAssignment = (evaluation, sprint, assignment) => {
    return dispatch => {
        dispatch({
            type: "SET_EVALUATION_SPRINT_AND_ASSIGNMENT",
            sprint,
            evaluation,
            assignment
        });
    }
}

export const setClassEvalsSprintAndAssignments = (classObject, sprint) => {
    return dispatch => {
        authAxios.get(`/api/class/assignment/student/${classObject._id}`)
            .then(response => {
                const classEvaluations = response.data;

                authAxios.get(`/api/class/${classObject._id}/assignment`)
                    .then(response => {
                        dispatch({
                            type: "SET_CLASS_ASSIGNMENTS_SPRINT_AND_EVALUATIONS",
                            classObject,
                            classEvaluations,
                            classAssignments: response.data,
                            sprint
                        });
                    })
                    .catch(error => {
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClass = (classId) => {
    return dispatch => {
        authAxios.get(`/api/class/${classId}`)
            .then(response => {
                dispatch({
                    type: "SET_CLASS",
                    classObject: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getStudentTasks = (studentId) => {
    return dispatch => {
        authAxios.get(`/api/task/student/${studentId}`)
            .then(response => {
                dispatch({
                    type: "GET_STUDENT_TASKS",
                    tasks: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getReviewingStudentEvaluations = (studentId) => {
    return dispatch => {
        authAxios.get(`/api/evaluation/reviewing/${studentId}`)
            .then(response => {
                dispatch({
                    type: "GET_STUDENT_REVIEWING_EVALUATIONS",
                    reviewingEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getStudentReviews = (studentId) => {
    return dispatch => {
        authAxios.get(`/api/review/student/${studentId}`)
            .then(response => {
                dispatch({
                    type: "GET_STUDENT_REVIEWS",
                    reviews: response.data.filter(review => review.status === "Graded")
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getTeacherAssignments = (teacherId) => {
    return dispatch => {
        authAxios.get(`/api/class/assignment/teacher/${teacherId}`)
            .then(response => {
                dispatch({
                    type: "GET_TEACHER_ASSIGNMENTS",
                    assignments: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getTeacherClasses = (teacherId) => {
    return dispatch => {
        authAxios.get("/api/class")
            .then(response => {
                dispatch({
                    type: "GET_TEACHER_CLASSES",
                    teacherClasses: response.data.filter(classObject => classObject.teachers.includes(teacherId))
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getTeacherArchivedClasses = (teacherId) => {
    return dispatch => {
        authAxios.get(`/api/class/teacher/${teacherId}/archived`)
            .then(response => {
                const list = Array.isArray(response.data) ? response.data : [];
                dispatch({
                    type: "GET_TEACHER_ARCHIVED_CLASSES",
                    teacherArchivedClasses: list
                });
            })
            .catch(error => {
                dispatch({
                    type: "GET_TEACHER_ARCHIVED_CLASSES",
                    teacherArchivedClasses: []
                });
                dispatch({
                    type: "ERROR",
                    error: error.response && error.response.statusText
                });
            });
    }
}

export const archiveTeacherClass = (teacherId, classId) => {
    return dispatch => {
        authAxios.put(`/api/class/${classId}/archive`)
            .then(() => {
                dispatch(getTeacherClasses(teacherId));
                dispatch(getTeacherArchivedClasses(teacherId));
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const unarchiveTeacherClass = (teacherId, classId) => {
    return dispatch => {
        authAxios.put(`/api/class/${classId}/unarchive`)
            .then(() => {
                dispatch(getTeacherClasses(teacherId));
                dispatch(getTeacherArchivedClasses(teacherId));
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const addClassToTeacher = (userId, classId, prevClasses) => {
    return dispatch => {
        authAxios.put(`/api/user/${userId}/class/${classId}/add`)
            .then(response => {
                const user = response.data;

                authAxios.put(`/api/class/${classId}/${userId}/add`)
                    .then(response => {
                        const teacherClasses = copy(prevClasses);
                        teacherClasses.push(response.data);

                        dispatch({
                            type: "GET_USER_TEACHER_CLASSES",
                            teacherClasses,
                            user
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function addClassToUser(userId, classId) {
    return dispatch => {
        authAxios.put(`/api/user/${userId}/class/${classId}/add`)
            .then(response => {
                dispatch({
                    type: "SET_USER",
                    user: response.data
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const getTasksEvaluations = (taskId) => {
    return dispatch => {
        authAxios.get(`/api/task/${taskId}/evaluations`)
            .then(response => {
                dispatch({
                    type: "GET_TASK_EVALUATIONS",
                    taskEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getReviewsEvaluations = (reviewId) => {
    return dispatch => {
        authAxios.get(`/api/evaluation/review/${reviewId}`)
            .then(response => {
                dispatch({
                    type: "GET_REVIEW_EVALUATIONS",
                    reviewEvaluations: response.data
                });
            })
            .catch(error => {
                console.log(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getStudentReviewEvaluations = (studentId) => {
    return dispatch => {
        authAxios.get(`/api/review/student/${studentId}`)
            .then(response => {

                const reviews = response.data.filter(review => review.status === "Graded")

                authAxios.put(`/api/evaluation/reviews`, {reviews})
                    .then(response => {
                        dispatch({
                            type: "GET_STUDENT_REVIEWS_AND_EVALUATIONS",
                            reviews,
                            studentReviewEvaluations: response.data
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getTeacherEvaluations = (teacherId) => {
    return dispatch => {
        authAxios.get(`/api/evaluation/teacher/${teacherId}`)
            .then(response => {
                dispatch({
                    type: "GET_TEACHER_EVALUATIONS",
                    teacherEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getEvaluations = (body, page, pageSize, sortMethod, teacherId) => {
    return dispatch => {
        return authAxios.post(`/api/evaluation/match/${page}/${pageSize}/${sortMethod.replace(" ", "_")}/${teacherId}`, body)
            .then(response => {
                dispatch({
                    type: "GET_TEACHER_EVALUATIONS_PAGINATED",
                    teacherEvaluations: response.data.evaluations,
                    numOfPages: response.data.numOfPages
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getTeacherStudents = (teacherId) => {
    return dispatch => {
        authAxios.get(`/api/user/teacher/${teacherId}`)
            .then(response => {
                dispatch({
                    type: "GET_TEACHER_STUDENTS",
                    teacherStudents: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}


export const getAssignment = (assignmentId) => {
    return dispatch => {
        authAxios.get(`/api/class/assignment/${assignmentId}`)
            .then(response => {
                dispatch({
                    type: "SET_ASSIGNMENT",
                    assignment: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSprint = (sprintId) => {
    return dispatch => {
        authAxios.get(`/api/sprint/${sprintId}`)
            .then(response => {
                console.log('getSprint:', response.data)
                dispatch({
                    type: "SET_SPRINT",
                    sprint: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSprints = (teacherId) => {
    return dispatch => {
        authAxios.get(`/api/sprint/teacher/${teacherId}`)
            .then(response => {
                dispatch({
                    type: "SET_SPRINTS",
                    sprints: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
} 

export const getAssignmentEvaluations = (assignmentId) => {
    return dispatch => {
        authAxios.get(`/api/evaluation/assignment/${assignmentId}`)
            .then(response => {
                dispatch({
                    type: "GET_ASSIGNMENT_EVALUATIONS",
                    assignmentEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassAssignments = (classObjectId) => {
    return dispatch => {
        authAxios.get(`/api/class/${classObjectId}/assignment`)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_ASSIGNMENTS",
                    classAssignments: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassesAssignments = (classObjectIds) => {
    return dispatch => {
        authAxios.post(`/api/class/assignment/student`, classObjectIds)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_ASSIGNMENTS",
                    classAssignments: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassesFromIds = (classObjectIds) => {
    return dispatch => {
        authAxios.post(`/api/class/student`, classObjectIds)
            .then(response => {
                dispatch({
                    type: "GET_CLASSES",
                    classes: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassesSprints = (classObjectIds) => {
    return dispatch => {
        authAxios.post('/api/sprint/student', classObjectIds)
            .then(response => {
                dispatch({
                    type: "GET_SPRINTS",
                    sprints: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassStudents = (classObjectId) => {
    return dispatch => {
        authAxios.get(`/api/class/${classObjectId}/student`)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_STUDENTS",
                    classStudents: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassesStudents = (classObjectIds) => {
    return dispatch => {
        authAxios.post(`/api/user/student`, classObjectIds)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_STUDENTS",
                    classStudents: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSprintEvaluations = (sprintId, studentId) => {
    return dispatch => {
        const suffix = studentId ? `${sprintId}/${studentId}` : sprintId;
        authAxios.get(`/api/sprint/evaluations/report/${suffix}`)
            .then(response => {
                dispatch({
                    type: "GET_SPRINT_EVALUATIONS",
                    sprintEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSprintGrades = (sprintId) => {
    return dispatch => {
        authAxios.get(`/api/sprint/evaluations/grades/${sprintId}`)
            .then(response => {
                dispatch({
                    type: "GET_SPRINT_GRADES",
                    sprintGrades: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}


export const getClassEvaluations = (classObjectId) => {
    return dispatch => {
        authAxios.get(`/api/class/assignment/student/${classObjectId}`)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_EVALUATIONS",
                    classEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getClassesEvaluations = (classObjectIds) => {
    return dispatch => {
        authAxios.post(`/api/evaluation/student`, classObjectIds)
            .then(response => {
                dispatch({
                    type: "GET_CLASS_EVALUATIONS",
                    classEvaluations: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSchoolTeachers = (schoolId) => {
    return dispatch => {
        authAxios.get(`/school/${schoolId}/teacher`)
            .then(response => {
                dispatch({
                    type: "GET_SCHOOL_TEACHERS",
                    schoolTeachers: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const getSchoolClasses = (schoolId) => {
    return dispatch => {
        authAxios.get(`/school/${schoolId}/class`)
            .then(response => {
                dispatch({
                    type: "GET_SCHOOL_CLASSES",
                    schoolClasses: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteAssignment = (assignmentId, oldAssignments, oldTeacherEvaluations) => {
    return dispatch => {
        authAxios.delete(`/api/class/assignment/${assignmentId}`)
            .then(response => {
                const assignments = oldAssignments.filter(assignmentItem => assignmentItem._id !== assignmentId);
                const teacherEvaluations = oldTeacherEvaluations.filter(evaluation => evaluation.assignment !== assignmentId)
                dispatch({
                    type: "DELETE_TEACHER_ASSIGNMENTS",
                    assignments,
                    teacherEvaluations
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteStudent = (studentId, oldStudents, oldEvaluations) => {
    return dispatch => {
        authAxios.delete(`/api/user/${studentId}`)
            .then(response => {
                const teacherStudents = oldStudents.filter(student => student._id !== studentId);
                const teacherEvaluations = oldEvaluations.filter(thisEval => thisEval.user !== studentId || thisEval.studentReviewed !== studentId);
                dispatch({
                    type: "GET_TEACHER_STUDENTS_AND_EVALUATIONS",
                    teacherStudents,
                    teacherEvaluations
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteSchool = (schoolId, prevSchools) => {
    return dispatch => {
        authAxios.delete(`/school/${schoolId}`)
            .then(response => {
                const schools = prevSchools.filter(school => school._id !== schoolId);
                dispatch({
                    type: "GET_SCHOOLS",
                    schools
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteAdminClass = (classId, oldSchoolClasses) => {
    return dispatch => {
        const schoolClasses = oldSchoolClasses.filter(thisClass => thisClass._id !== classId);

        authAxios.delete(`/api/class/${classId}`)
            .then(response => {
                dispatch({
                    type: "GET_SCHOOL_CLASSES",
                    schoolClasses
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const deleteClass = (classId, prevClasses, prevPossibleClasses, prevAssignments, prevTeacherStudents, prevTeacherEvaluations, prevSprints) => {
    return dispatch => {
        authAxios.delete(`/api/class/${classId}`)
            .then(response => {
                dispatch({
                    type: "DELETE_TEACHER_CLASSES",
                    teacherClasses: prevClasses.filter(classObject => classObject._id !== classId),
                    possibleClasses: prevPossibleClasses.filter(classObject => classObject._id !== classId),
                    assignments: prevAssignments.filter(assignment => assignment.class !== classId),
                    // eslint-disable-next-line
                    teacherStudents: prevTeacherStudents.filter(student => student.classes.filter(thisClassId => classId != thisClassId).length > 0),
                    teacherEvaluations: prevTeacherEvaluations.filter(evaluation => evaluation.class !== classId),
                    sprints: prevSprints.filter(sprint => sprint.class !== classId)
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteTeacherClass = (classId, prevClasses, prevPossibleClasses, prevAssignments, prevTeacherStudents, prevTeacherEvaluations, prevSprints) => {
    return dispatch => {
        authAxios.delete(`/api/class/teacher/${classId}`)
            .then(response => {
                dispatch({
                    type: "DELETE_TEACHER_CLASSES",
                    teacherClasses: prevClasses.filter(classObject => classObject._id !== classId),
                    possibleClasses: prevPossibleClasses.filter(classObject => classObject._id !== classId),
                    assignments: prevAssignments.filter(assignment => assignment.class !== classId),
                    // eslint-disable-next-line
                    teacherStudents: prevTeacherStudents.filter(student => student.classes.filter(thisClassId => classId != thisClassId).length > 0),
                    teacherEvaluations: prevTeacherEvaluations.filter(evaluation => evaluation.class !== classId),
                    sprints: prevSprints.filter(sprint => sprint.class !== classId)
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteSprint = (sprintId, prevSprints, teacherClasses, prevAssignments, prevTeacherEvaluations) => {
    return dispatch => {
        authAxios.delete(`/api/sprint/${sprintId}`)
            .then(response => {
                const update = teacherClasses.map((c) => {
                  if (c.currentSprint === sprintId) {
                    const u = {
                      ...c,
                    };
                    delete u.currentSprint;
                    return u;
                  }
                  return c;
                });

                dispatch({
                    type: "DELETE_SPRINT",
                    sprints: prevSprints.filter(sprint => sprint._id !== sprintId),
                    teacherClasses: update,
                    assignments: prevAssignments.filter(assignment => assignment.sprint !== sprintId),
                    teacherEvaluations: prevTeacherEvaluations.filter(evaluation => evaluation.sprint !== sprintId)
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response ? error.response.statusText : error
                });
            });
    }
}

export const releaseSprint = (sprintId, classId, prevSprints, prevClasses) => {
    return dispatch => {
        const releaseDate = Date.now();
        authAxios.put(`/api/sprint/release/${sprintId}`, {releaseDate})
            .then(response => {
                const sprints = copy(prevSprints);
                const editSprint = sprints.find(sprint => sprint._id === sprintId);
                editSprint.releaseDate = releaseDate;
                editSprint.status = "Released";
                const teacherEvaluations = response.data;

                authAxios.put(`/api/class/${classId}`, {currentSprint: null})
                    .then(response => {
                        const teacherClasses = copy(prevClasses);
                        const editClass = teacherClasses.find(classObject => classObject.currentSprint === sprintId);
                        delete editClass.currentSprint

                        dispatch({
                            type: "RELEASE_SPRINT",
                            sprints,
                            teacherClasses,
                            teacherEvaluations
                        });
                    })
                    .catch(error => {
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const setCurrentSprint = (sprintId, classId, prevClasses) => {
    return dispatch => {
        authAxios.put(`/api/class/${classId}`, {currentSprint: sprintId})
            .then(response => {
                const teacherClasses = [...(prevClasses || [])];
                const classObject = teacherClasses.find(
                  (classObject) => classObject._id === classId
                );
                dispatch({
                  type: "GET_TEACHER_CLASSES_AND_UPDATED_CLASS",
                  teacherClasses,
                  classObject: {
                    ...(classObject || {}),
                    currentSprint: sprintId,
                  },
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error && error.response && error.response.statusText
                });
            });
    }
}

export const deleteFeedback = (feedbackId, oldFeedback) => {
    return dispatch => {
        authAxios.delete(`/feedback/${feedbackId}`)
            .then(response => {
                const feedback = oldFeedback.filter(feedback => feedback._id !== feedbackId);
                dispatch({
                    type: "GET_FEEDBACK",
                    feedback
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const clearFeedbackError = () => {
    return dispatch => {
        dispatch({
            type: "CLEAR_ERROR"
        });
    }
}

export const addFeedback = (feedback) => {
    return dispatch => {
        noAuthAxios.post("/feedback", feedback)
            .then(() => {
                dispatch({
                    type: "CLEAR_FEEDBACK_ERROR"
                });
            })
            .catch(error => {
                dispatch({
                    type: "FEEDBACK_ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteTeacher = (userId, oldSchoolTeachers) => {
    return dispatch => {
        const schoolTeachers = oldSchoolTeachers.filter(teacher => teacher._id !== userId);

        authAxios.delete(`/api/user/${userId}`)
            .then(response => {
                dispatch({
                    type: "GET_SCHOOL_AND_SCHOOL_TEACHERS",
                    schoolTeachers
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const editTeacherAdmin = (teacherId, newTeacher, oldSchoolTeachers) => {
    return dispatch => {
        authAxios.put(`/api/user/${teacherId}`, newTeacher)
            .then(response => {
                const schoolTeachers = copy(oldSchoolTeachers);
                const editedTeacher = schoolTeachers.find(thisTeacher => thisTeacher._id === teacherId);
                for (let key in response.data) {
                    editedTeacher[key] = response.data[key]
                }
                dispatch({
                    type: "GET_SCHOOL_TEACHERS",
                    schoolTeachers
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const addRequest = (request, oldRequests) => {
    return dispatch => {
        authAxios.post("/request", request)
            .then(response => {
                const requests = copy(oldRequests);
                requests.push(response.data);
                dispatch({
                    type: "GET_REQUESTS",
                    requests
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const addSchool = (school, previousSchools) => {
    return dispatch => {
        authAxios.post("/school", school)
            .then(response => {
                const schools = copy(previousSchools);
                schools.push(response.data);
                dispatch({
                    type: "GET_SCHOOLS",
                    schools
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const addSprint = (sprint, oldSprints) => {
    return (dispatch, getState) => {
        authAxios.post("/api/sprint/", sprint)
            .then(response => {
                const sprint = response.data;
                const sprints = copy(oldSprints);
                sprints.push(sprint);
                // Make the newly-created sprint the active sprint for its class
                // so the teacher immediately sees it on the dashboard.
                authAxios.put(`/api/class/${sprint.class}`, { currentSprint: sprint._id })
                    .then(() => {
                        const teacherClasses = ((getState() || {}).root || {}).teacherClasses || [];
                        const updatedTeacherClasses = teacherClasses.map((c) =>
                            `${c._id}` === `${sprint.class}`
                                ? { ...c, currentSprint: sprint._id }
                                : c
                        );
                        const updatedClassObject =
                            updatedTeacherClasses.find((c) => `${c._id}` === `${sprint.class}`) || {};
                        dispatch({
                            type: "GET_TEACHER_CLASSES_AND_UPDATED_CLASS",
                            teacherClasses: updatedTeacherClasses,
                            classObject: updatedClassObject,
                        });
                    })
                    .catch(() => {
                        // If this fails, we can still show the sprint in the list.
                    });
                dispatch({
                    type: "GET_SPRINTS",
                    sprints
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const addEvaluation = (evaluationInfo, previousEvaluations) => {
    return dispatch => {
        authAxios.post(`/api/v2/evaluations`, evaluationInfo)
            .then(response => {
                const reviewingEvaluations = copy(previousEvaluations);
                reviewingEvaluations.push(response.data);
                dispatch({
                    type: "EDIT_STUDENT_REVIEWING_EVALUATIONS",
                    reviewingEvaluations
                });
                dispatch(
                    createEvent({
                        type: "added_evaluation",
                        data: { evaluation: response.data },
                      })
                )
            })
            .catch(error => {
                console.log(error);
                dispatch(signupError("editEvals", {status: error.response.status, message: error.response.data.message}));
            });
    }
}

export const deleteEvaluation = (evalId, oldReviewingEvaluations) => {
    return dispatch => {
        authAxios.delete(`/api/evaluation/${evalId}`)
            .then(response => {
                const reviewingEvaluations = copy(oldReviewingEvaluations).filter(evaluation => evaluation._id !== evalId)
                dispatch({
                    type: "EDIT_STUDENT_REVIEWING_EVALUATIONS",
                    reviewingEvaluations
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const deleteRequest = (requestId, oldRequests) => {
    return dispatch => {
        authAxios.delete(`/request/${requestId}`)
            .then(response => {
                const requests = copy(oldRequests).filter(request => request._id !== requestId)
                dispatch({
                    type: "GET_REQUESTS",
                    requests
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const grantRequest = (request, oldRequests, oldTeacherClasses) => {
    return dispatch => {
        authAxios.put(`/api/user/${request.teacher}/class/${request.class}/add`)
            .then(response => {

                authAxios.put(`/api/class/${request.class}/${request.teacher}/add`)
                    .then(response => {

                        const teacherClasses = copy(oldTeacherClasses);
                        const changedClass = teacherClasses.find(classObject => classObject._id === request.class);
                        changedClass.teachers.push(request.teacher);

                        authAxios.delete(`/request/${request._id}`)
                            .then(response => {

                                const requests = copy(oldRequests).filter(thisRequest => thisRequest._id !== request._id);
                                dispatch({
                                    type: "GET_REQUESTS_AND_CLASSES",
                                    requests,
                                    teacherClasses
                                });
                            })
                            .catch(error => {
                                dispatch({
                                    type: "ERROR",
                                    error: error.response.statusText
                                });
                            });
                    })
                    .catch(error => {
                        console.log(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const clearRequest = (requestId, oldRequests) => {
    return dispatch => {
        authAxios.delete(`/request/${requestId}`)
            .then(response => {
                const requests = copy(oldRequests).filter(request => request._id !== requestId)
                dispatch({
                    type: "GET_REQUESTS",
                    requests
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const denyRequest = (requestId, oldRequests) => {
    return dispatch => {
        authAxios.put(`/request/${requestId}`, {status: "Denied"})
            .then(response => {
                const requests = copy(oldRequests)
                const request = requests.find(request => request._id === requestId);
                if (request) {
                    request.status = "Denied";
                }
                dispatch({
                    type: "GET_REQUESTS",
                    requests
                });
            })
            .catch(error => {
                const message = error && error.response && error.response.statusText;
                dispatch({
                    type: "ERROR",
                    error: message || error
                });
            });
    }
}

export const deleteTeacherEvaluation = (evalId, oldReviewingEvaluations) => {
    return dispatch => {
        authAxios.delete(`/api/evaluation/${evalId}`)
            .then(response => {
                const teacherEvaluations = oldReviewingEvaluations.filter(evaluation => evaluation._id !== evalId)
                dispatch({
                    type: "GET_TEACHER_EVALUATIONS",
                    teacherEvaluations
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const editEvaluation = (evaluation, evalId, oldReviewingEvaluations) => {
    return dispatch => {
        authAxios.put(`/api/evaluation/${evalId}`, evaluation)
            .then(response => {
                const reviewingEvaluations = copy(oldReviewingEvaluations);
                const editedEvaluation = reviewingEvaluations.find(thisEval => thisEval._id === evalId);
                for (let key in response.data) {
                    editedEvaluation[key] = response.data[key]
                }
                dispatch({
                    type: "EDIT_STUDENT_REVIEWING_EVALUATIONS",
                    reviewingEvaluations
                });
            })
            .catch(error => {
                dispatch(signupError("editEvals", {status: error.response.status, message: error.response.data.message}));
            });
    }
}

export const addClass = (classObject, classes) => {
    return dispatch => {
        authAxios.post(`/api/class/`, classObject)
            .then(response => {
                const teacherClasses = copy(classes);
                teacherClasses.push(response.data);
                dispatch({
                    type: "GET_TEACHER_CLASSES",
                    teacherClasses
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const createClassTeacher = (userId, classObject, prevClasses, prevPossibleClasses) => {
    return dispatch => {
        authAxios.post(`/api/class/`, classObject)
            .then(response => {
                const newClass = response.data;
                const teacherClasses = copy(prevClasses);
                teacherClasses.push(newClass);

                const possibleClasses = copy(prevPossibleClasses);
                possibleClasses.push(newClass);

                authAxios.put(`/api/user/${userId}/class/${newClass._id}/add`)
                    .then(response => {
                        dispatch({
                            type: "GET_USER_AND_TEACHER_POSSIBLE_CLASSES",
                            teacherClasses,
                            possibleClasses,
                            user: response.data
                        });
                    })
                    .catch(error => {
                        console.error(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    })
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const signup = (userInfo) => {
    return dispatch => {
        noAuthAxios.post("/auth/signup", userInfo)
            .then(response => {
                const {token, user} = response.data;
                localStorage.token = token;
                localStorage.user = JSON.stringify(user);
                dispatch(authenticate(user));
                dispatch({
                    type: "SIGNUP_SUCCESS",
                    user
                });
                dispatch(
                    createEvent({
                      type: "signup",
                      data: { user },
                    })
                  );
            })
            .catch(err => {
                console.error(err);
                dispatch(signupError("signup", {status: err.response.status, message: err.response.data.message}));
            })
    }
}

export const signupTeacher = (userInfo) => {
    return dispatch => {
        noAuthAxios.post("/auth/signup", userInfo)
            .then(response => {
                const {token, user} = response.data;
                localStorage.token = token;
                localStorage.user = JSON.stringify(user);
                dispatch(authenticate(user));
            })
            .catch(err => {
                console.error(err);
                dispatch(signupError("signup", {status: err.response.status, message: err.response.data.message}));
            })
    }
}

export const signupTeacherRequest = (userInfo, classObject) => {
    return dispatch => {
        noAuthAxios.post("/auth/signup", userInfo)
            .then(response => {
                const {token, user} = response.data;
                localStorage.token = token;
                localStorage.user = JSON.stringify(user);

                noAuthAxios.post("/request", {
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    teacher: user._id,
                    class: classObject._id,
                    className: classObject.name
                }).then(response => {
                    dispatch(authenticate(user));
                }).catch(error => {
                    dispatch({
                        type: "ERROR",
                        error: error.response.statusText
                    });
                });
            })
            .catch(err => {
                console.error(err);
                dispatch(signupError("signup", {status: err.response.status, message: err.response.data.message}));
            })
    }
}

export function login(credentials){
    return dispatch => {
        noAuthAxios.post('/auth/login', credentials)
            .then(response => {
                const {token, user} = response.data;
                localStorage.token = token
                localStorage.user = JSON.stringify(user);
                dispatch(authenticate(user));
                dispatch(
                  createEvent({
                    type: "login",
                    data: { user },
                  })
                );
            })
            .catch((err) => {
                console.error(err);
                dispatch(signupError("signin", {status: err.response.status, message: err.response.data.message}));
            });
    }
}

export function verify() {
    // Verify the user's token
    return dispatch => {
        const params = new URL(window.location).searchParams;
        if (params.get('token')) {
            localStorage.token = params.get('token')
        }
        authAxios.get("/profile/verify")
            .then((response) => {
                let { user } = response.data;
                dispatch(authenticate(user));
            })
            .catch((error) => {
                console.error(error);
                if(error.response.status === 401) {
                    dispatch(logout());
                    return;
                }
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function logout(){
    delete localStorage.token;
    delete localStorage.user;
    return {
        type: "LOGOUT"
    }
}

export function authenticate(user) {
    return {
        type: "AUTHENTICATE",
        user
    }
}

function signupError(key, errCode) {
    return {
        type: "SIGNUP_ERROR",
        key,
        errCode
    }
}

export function changePassword(newPassword) {
    return (dispatch) => {
        authAxios.put("/auth/change-password", {newPassword})
            .then((response) => {
                dispatch(signupError("changePassword", ""));
            })
            .catch((err) => {
                console.error(err);
                dispatch(signupError("changePassword", err.response.status));
            })
    }
}

export function forgotPassword(email) {
    return (dispatch) => {
        dispatch({type: "FORGOT_PASSWORD_PENDING"});
        noAuthAxios.post("/auth/forgot", {email})
            .then((response) => {
                if(response && response.response && response.response.status > 399) {
                    dispatch(signupError("forgotPassword", response.response.status));
                } else {
                    dispatch(signupError("forgotPassword", 200));
                }
            })
            .catch((err) => {
                dispatch(signupError("forgotPassword", err.response.status));
            })
    }
}

// Resolves to true only if the server actually accepted the new password, so the
// caller can avoid telling the user it worked when it didn't.
export function resetPassword(password, resetToken) {
    return (dispatch) => {
        return noAuthAxios.post(`/auth/reset/${resetToken}`, {password})
            .then((response) => {
                // The noAuthAxios interceptor above resolves non-401 failures with the
                // AxiosError instead of rejecting, so a 4xx arrives here, not in .catch.
                // A swallowed error carries the real response under `response.response`.
                const status = response && response.response
                    ? response.response.status
                    : response && response.status;

                if (!status || status > 399) {
                    dispatch(signupError("changePassword", status || 500));
                    return false;
                }

                dispatch(signupError("changePassword", ""));
                return true;
            })
            .catch((err) => {
                console.error(err);
                // A network failure has no `err.response`, so fall back to a generic 500.
                dispatch(signupError("changePassword", err.response ? err.response.status : 500));
                return false;
            })
    }
}

export function editUser(user) {
    return dispatch => {
        authAxios.put("/api/user/", user)
            .then(response => {
                dispatch(authenticate(response.data))
            })
            .catch(err => {
                console.error(err);
                dispatch(signupError("edit", err.response.status));
            })
    }
}

export function removeClassFromUser(userId, classId) {
    return dispatch => {
        authAxios.put(`/api/user/${userId}/class/${classId}/remove`)
            .then(response => {
                dispatch({
                    type: "SET_USER",
                    user: response.data
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function removeClassFromTeacher(userId, classId, prevClasses) {
    return dispatch => {
        authAxios.put(`/api/user/${userId}/class/${classId}/remove`)
            .then(response => {
                const user = response.data;

                authAxios.put(`/api/class/${classId}/${userId}/remove`)
                    .then(response => {

                        dispatch({
                            type: "GET_USER_TEACHER_CLASSES",
                            // eslint-disable-next-line
                            teacherClasses: prevClasses.filter(thisClass => thisClass._id != classId),
                            user
                        });
                    })
                    .catch(error => {
                        console.error(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const addStudent = (user, oldTeacherStudents) => {
    return dispatch => {
        authAxios.post("/api/user/", user)
            .then(response => {
                const student = response.data
                const teacherStudents = copy(oldTeacherStudents);
                teacherStudents.push(student)
                dispatch({
                    type: "GET_TEACHER_STUDENTS",
                    teacherStudents
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function addStudents(students, oldTeacherStudents) {
    return dispatch => {
        authAxios.post("/api/user/students", students)
            .then(response => {
                const students = response.data
                const teacherStudents = copy(oldTeacherStudents);
                teacherStudents.push(...students)
                dispatch({
                    type: "GET_TEACHER_STUDENTS",
                    teacherStudents
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function addAssignment(assignment, oldAssignments) {
    return dispatch => {
        authAxios.post(`/api/class/assignment/`, assignment)
            .then(response => {
                const assignments = copy(oldAssignments);
                assignments.push(response.data);

                dispatch({
                    type: "SET_TEACHER_ASSIGNMENTS",
                    assignments
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function editAssignment(assignment, assignmentId, oldAssignments) {
    return dispatch => {
        authAxios.put(`/api/class/assignment/${assignmentId}`, assignment)
            .then(response => {
                const assignments = copy(oldAssignments)
                const editedAssignment = assignments.find(thisAssignment => thisAssignment._id === assignmentId);

                for (let key in response.data) {
                    editedAssignment[key] = response.data[key]
                }

                dispatch({
                    type: "SET_TEACHER_ASSIGNMENTS",
                    assignments
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function editStudent(studentId, user, oldTeacherStudents, teacherId) {
    return dispatch => {
        authAxios.put(`/api/user/${studentId}`, user)
            .then(response => {
                const teacherStudents = copy(oldTeacherStudents);
                const editedStudent = teacherStudents.find(student => student._id === studentId);
                for (let key in response.data) {
                    editedStudent[key] = response.data[key]
                }

                authAxios.put(`/api/evaluation/studentEdit/${studentId}`, user)
                    .then(response => {

                      authAxios.get(`/api/evaluation/teacher/${teacherId}`)
                          .then(response => {
                              dispatch({
                                  type: "GET_TEACHER_STUDENTS_AND_EVALUATIONS",
                                  teacherStudents,
                                  teacherEvaluations: response.data
                              });
                          })
                          .catch(error => {
                              dispatch({
                                  type: "ERROR",
                                  error: error.response.statusText
                              });
                          });
                    })
                    .catch(error => {
                        console.error(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    })
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function editClass(classObject, oldTeacherClasses, oldPossibleClasses, classObjectId) {
    return dispatch => {
        authAxios.put(`/api/class/${classObjectId}`, classObject)
            .then(response => {
                const teacherClasses = copy(oldTeacherClasses);
                const possibleClasses = copy(oldPossibleClasses);
                const editedClass = teacherClasses.find(thisClassObject => thisClassObject._id === classObjectId);
                const editedClass2 = possibleClasses.find(thisClassObject => thisClassObject._id === classObjectId);

                for (let key in response.data) {
                    editedClass[key] = response.data[key]
                    editedClass2[key] = response.data[key]
                }

                dispatch({
                    type: "SET_TEACHER_CLASSES_AND_CLASS",
                    teacherClasses,
                    possibleClasses,
                    classObject: response.data
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function editSchool(school, oldSchools, schoolId) {
    return dispatch => {
        noAuthAxios.put(`/school/${schoolId}`, school)
            .then(response => {
                const schools = copy(oldSchools);
                const editedSchool = schools.find(thisSchool => thisSchool._id === schoolId);
                for (let key in school) {
                    editedSchool[key] = school[key]
                }
                dispatch({
                    type: "GET_SCHOOLS",
                    schools
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}





export function releaseStudentReviewEvaluations(assignmentId, oldAssignments, oldEvaluations) {
    return dispatch => {
        authAxios.put(`/api/class/assignment/reviewed/${assignmentId}`)
            .then(response => {

                const assignments = copy(oldAssignments);
                assignments.find(thisAssignment => thisAssignment._id === assignmentId).status = "Reviewed";

                authAxios.put(`/api/evaluation/reviewed/${assignmentId}`)
                    .then(response => {

                        dispatch({
                            type: "GET_TEACHER_EVALUATIONS_AND_ASSIGNMENTS",
                            teacherEvaluations: response.data,
                            assignments
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    })
            })
            .catch(error => {
                console.log(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function releaseStudentReviews(assignmentId, oldAssignments, oldEvaluations) {
    return dispatch => {
        authAxios.put(`/api/class/assignment/graded/${assignmentId}`)
            .then(response => {

                const assignments = copy(oldAssignments);
                assignments.find(thisAssignment => thisAssignment._id === assignmentId).status = "Graded";

                authAxios.put(`/api/evaluation/graded/${assignmentId}`)
                    .then(response => {

                        dispatch({
                            type: "GET_TEACHER_EVALUATIONS_AND_ASSIGNMENTS",
                            teacherEvaluations: response.data,
                            assignments
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        dispatch({
                            type: "ERROR",
                            error: error.response.statusText
                        });
                    })
            })
            .catch(error => {
                console.log(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const editEvaluationTeacher = (evaluation, prevTeacherEvaluations) => {
    return dispatch => {
        authAxios.put(`/api/evaluation/${evaluation._id}`, evaluation)
            .then(response => {
                const teacherEvaluations = copy(prevTeacherEvaluations);
                const editedEvaluation = teacherEvaluations.find(thisEvaluation => thisEvaluation._id === evaluation._id);
                for (let key in response.data) {
                    editedEvaluation[key] = response.data[key]
                }
                dispatch({
                    type: "GET_TEACHER_EVALUATIONS",
                    teacherEvaluations
                });
            })
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export function addTeacher(user, oldSchoolTeachers) {
    return dispatch => {
        authAxios.post("/api/user/", user)
            .then(response => {
                const schoolTeachers = copy(oldSchoolTeachers);
                schoolTeachers.push(response.data);

                dispatch({
                    type: "GET_SCHOOL_TEACHERS",
                    schoolTeachers
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            })
    }
}

export const editTeacher = (teacher) => {
    return dispatch => {
        authAxios.put("/api/user", teacher)
            .catch(error => {
                dispatch({
                    type: "ERROR",
                    error: error.response.statusText
                });
            });
    }
}

export const setLoadingAssets = (loadingAssets) => {
    return dispatch => {
        dispatch({
            type: "LOADING_ASSETS",
            loadingAssets
        });
    }
}



// const initialState = {
//     schools: [],
//     classes: [],
//     tasks: [],
//     reviews: [],
//     assignments: [],
//     teacherClasses: [],
//     task: {},
//     review: {},
//     evaluation: {},
//     assignment: {},
//     classObject: {},
//     taskEvaluations: [],
//     reviewEvaluations: [],
//     assignmentEvaluations: [],
//     studentReviewEvaluations: [],
//     studentTaskEvaluations: [],
//     assignmentReviews: [],
//     classStudents: [],
//     classReviews: [],
//     classEvaluations: [],
//     student: {},
//     feedback: [],
//     school: {},
//     schoolTeachers: [],
//     user: {
//         _id: "",
//         email: "",
//         firstName: "",
//         lastName: "",
//         studentId: "",
//         class: "",
//         school: "",
//         type: ""
//     },
//     authErrCode: {
//         signup: "",
//         signin: {status: "", message: ""},
//         changePassword: "",
//         forgotPassword: "",
//         edit: ""
//     },
//     stripeError: "",
//     isAuthenticated: false,
//     loading: false,
//     error: ""
// };

const initialState = {
    feedback: [],
    schools: [],
    school: {},
    schoolTeachers: [],
    schoolClasses: [],
    user: {
        _id: "",
        email: "",
        firstName: "",
        lastName: "",
        studentId: "",
        class: "",
        school: "",
        type: ""
    },
    authErrCode: {
        signup: {status: "", message: ""},
        signin: {status: "", message: ""},
        editEvals: {status: "", message: ""},
        changePassword: "",
        forgotPassword: "",
        edit: ""
    },
    isAuthenticated: null,
    stripeError: "",
    classes: [],
    class: {},
    classStudents: [],
    error: "",
    reviewingEvaluations: [],
    classEvaluations: [],
    classAssignments: [],
    teacherEvaluations: [],
    teacherStudents: [],
    assignments: [],
    assignment: {},
    evaluation: {},
    teacherClasses: [],
    teacherArchivedClasses: [],
    classObject: {},
    sprints: [],
    sprint: {},
    sprintEvaluations: [],
    sprintGrades: [],
    possibleClasses: [],
    requests: [],
    classIndex: 0,
    numOfPages: 1,
    loadingAssets: {
        gradingEvaluations: false,
        teacherClasses: false,
    }
}




//     school: {},
//     schoolTeachers: [],
//     user: {
//         _id: "",
//         email: "",
//         firstName: "",
//         lastName: "",
//         studentId: "",
//         class: "",
//         school: "",
//         type: ""
//     },
//     authErrCode: {
//         signup: "",
//         signin: {status: "", message: ""},
//         changePassword: "",
//         forgotPassword: "",
//         edit: ""
//     },
//     stripeError: "",
//     isAuthenticated: false,
//     loading: false,
//     error: ""
// };

export const reducer = (prevState = initialState, action) => {
    switch (action.type) {
        case "AUTHENTICATE":
            return {
                ...prevState,
                isAuthenticated: true,
                user: {
                    ...action.user
                },
                authErrCode: {
                    signup: {status: "", message: ""},
                    signin: {status: "", message: ""},
                    changePassword: "",
                    forgotPassword: "",
                    edit: "",
                    editEvals: {status: "", message: ""}
                }
            }
        case "LOGOUT":
            return {
                ...initialState,
                isAuthenticated: false
            };
        case "FORGOT_PASSWORD_PENDING":
            return {
                ...prevState,
                pending: 'forgotPassword'
            };
        case "SIGNUP_ERROR":
            return {
                ...prevState,
                authErrCode: {
                    ...prevState.authErrCode,
                    [action.key]: action.errCode
                },
                pending: undefined
            };
        case "RESET_ERROR_STATUS":
            return {
                ...prevState,
                authErrCode: {
                    signup: {status: "", message: ""},
                    signin: {status: "", message: ""},
                    changePassword: "",
                    forgotPassword: "",
                    edit: "",
                    editEvals: {status: "", message: ""}
                }
            };
        case "STRIPE_ERROR":
            return {
                ...prevState,
                stripeError: action.err
            };
        case "LOADING":
            return {
                ...prevState,
                loading: true
            };
        case "ERROR":
            return {
                ...prevState,
                loading: false,
                error: action.error
            };
        case "CLEAR_FEEDBACK_ERROR":
            return {
                ...prevState,
                feedbackError: null,
            }
        case "FEEDBACK_ERROR":
            return {
                ...prevState,
                feedbackError: action.error,
            }
        case "GET_SCHOOLS":
            return {
                ...prevState,
                schools: action.schools
            }
        case "SET_SCHOOL":
            return {
                ...prevState,
                school: action.school
            }
        case "SET_USER":
            return {
                ...prevState,
                user: {
                    ...action.user
                }
            }
        case "GET_CLASSES":
            return {
                ...prevState,
                classes: action.classes
            }
        case "GET_POSSIBLE_CLASSES":
            return {
                ...prevState,
                possibleClasses: action.possibleClasses
            }
        case "SET_CLASS_AND_EVALUATIONS":
            return {
                ...prevState,
                classEvaluations: action.classEvaluations,
                classObject: action.classObject
            }
        case "GET_ASSIGNMENTS_REVIEWS":
            return {
                ...prevState,
                assignmentReviews: action.assignmentReviews
            }
        case "GET_FEEDBACK":
            return {
                ...prevState,
                feedback: action.feedback
            }
        case "SET_TASK":
            return {
                ...prevState,
                task: action.task
            }
        case "SET_REVIEW":
            return {
                ...prevState,
                review: action.review
            }
        case "SET_EVALUATION":
            return {
                ...prevState,
                evaluation: action.evaluation
            }
        case "SET_ASSIGNMENT":
            return {
                ...prevState,
                assignment: action.assignment
            }
        case "SET_SPRINT":{
            return {
                ...prevState,
                sprint: action.sprint
            }}
        case "SET_SPRINTS":
            return {
                ...prevState,
                sprints: action.sprints
            }
        case "SET_STUDENT":
            return {
                ...prevState,
                student: action.student
            }
        case "SET_TEACHER_ASSIGNMENTS":
            return {
                ...prevState,
                assignments: action.assignments
            }
        case "SET_CLASS_ASSIGNMENTS":
            return {
                ...prevState,
                classAssignments: action.classAssignments
            }
        case "SET_CLASS_ASSIGNMENTS_SPRINT_AND_EVALUATIONS":{
            return {
                ...prevState,
                classAssignments: action.classAssignments,
                classEvaluations: action.classEvaluations,
                classObject: action.classObject,
                sprint: action.sprint
            }}
        case "SET_CLASS":
            return {
                ...prevState,
                classObject: action.classObject
            }
        case "SET_CLASS_INDEX":
            return {
                ...prevState,
                classIndex: action.classIndex
            }
        case "SET_EVALUATION_AND_EVALUATIONS":
            return {
                ...prevState,
                evaluation: action.evaluation,
                assignmentEvaluations: action.assignmentEvaluations
            }
        case "GET_STUDENT_TASKS":
            return {
                ...prevState,
                tasks: action.tasks
            }
        case "GET_STUDENT_REVIEWS":
            return {
                ...prevState,
                reviews: action.reviews
            }
        case "GET_USER_TEACHER_CLASSES":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                user: action.user
            }
        case "ADD_CLASS":
            return {
                ...prevState,
                teacherClasses: [
                    ...(prevState.teacherClasses || []),
                    action.class
                ],
                loadingAssets: {
                    ...prevState.loadingAssets,
                    teacherClasses: false,
                }
            }
        case "GET_TEACHER_CLASSES":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                loadingAssets: {
                    ...prevState.loadingAssets,
                    teacherClasses: false,
                }
            }
        case "GET_TEACHER_ARCHIVED_CLASSES":
            return {
                ...prevState,
                teacherArchivedClasses: Array.isArray(action.teacherArchivedClasses)
                    ? action.teacherArchivedClasses
                    : [],
            }
        case "GET_TEACHER_CLASSES_AND_UPDATED_CLASS":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                classObject: action.classObject
            }
        case "GET_REQUESTS_AND_CLASSES":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                requests: action.requests
            }
        case "GET_TEACHER_ASSIGNMENTS":
            return {
                ...prevState,
                assignments: action.assignments
            }
        case "GET_TASK_EVALUATIONS":
            return {
                ...prevState,
                taskEvaluations: action.taskEvaluations
            }
        case "GET_REVIEW_EVALUATIONS":
            return {
                ...prevState,
                reviewEvaluations: action.reviewEvaluations
            }
        case "GET_REQUESTS":
            return {
                ...prevState,
                requests: action.requests
            }
        case "GET_ASSIGNMENT_EVALUATIONS":
            return {
                ...prevState,
                assignmentEvaluations: action.assignmentEvaluations
            }
        case "GET_CLASS_ASSIGNMENTS":
            return {
                ...prevState,
                classAssignments: action.classAssignments
            }
        case "GET_CLASS_STUDENTS":
            return {
                ...prevState,
                classStudents: action.classStudents
            }
        case "GET_SPRINTS":
            return {
                ...prevState,
                sprints: action.sprints
            }
        case "GET_SCHOOL_TEACHERS":
            return {
                ...prevState,
                schoolTeachers: action.schoolTeachers
            }
        case "GET_SCHOOL_CLASSES":
            return {
                ...prevState,
                schoolClasses: action.schoolClasses
            }
        case "DELETE_TEACHER_ASSIGNMENTS":
            return {
                ...prevState,
                assignments: action.assignments,
                assignment: {},
                teacherEvaluations: action.teacherEvaluations
            }
        case "DELETE_SPRINT":
            return {
                ...prevState,
                assignments: action.assignments,
                sprints: action.sprints,
                teacherClasses: action.teacherClasses,
                teacherEvaluations: action.teacherEvaluations
            }
        case "RELEASE_SPRINT":
            return {
                ...prevState,
                sprints: action.sprints,
                teacherEvaluations: action.teacherEvaluations,
                teacherClasses: action.teacherClasses
            }
        case "DELETE_TEACHER_CLASSES":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                possibleClasses: action.possibleClasses,
                assignments: action.assignments,
                teacherStudents: action.teacherStudents,
                teacherEvaluations: action.teacherEvaluations,
                sprints: action.sprints
            }
        case "DELETE_STUDENT":
            return {
                ...prevState,
                classObject: action.classObject,
                classStudents: action.classStudents
            }
        case "DELETE_SCHOOL":
            return {
                ...prevState,
                schools: action.schools,
                schoolTeachers: [],
                school: {}
            }
        case "ADD_SCHOOL":
            return {
                ...prevState,
                school: action.school,
                schools: action.schools
            }
        case "GET_SCHOOL_AND_SCHOOL_TEACHERS":
            return {
                ...prevState,
                schoolTeachers: action.schoolTeachers
            }
        case "GET_TASK_EVALUATIONS_AND_REVIEWS":
            return {
                ...prevState,
                taskEvaluations: action.taskEvaluations,
                reviews: action.reviews
            }
        case "GET_STUDENT_REVIEWS_AND_EVALUATIONS":
            return {
                ...prevState,
                studentReviewEvaluations: action.studentReviewEvaluations,
                reviews: action.reviews
            }
        case "EDIT_ASSIGNMENT":
            return {
                ...prevState,
                assignments: action.assignments,
                assignmentEvaluations: action.assignmentEvaluations
            }
        case "GET_STUDENT_TASKS_AND_EVALUATIONS":
            return {
                ...prevState,
                studentTaskEvaluations: action.studentTaskEvaluations,
                tasks: action.tasks
            }
        case "GET_CLASS_EVALUATIONS":
            return {
                ...prevState,
                classEvaluations: action.classEvaluations
            }
        case "GET_SPRINT_EVALUATIONS":
            return {
                ...prevState,
                sprintEvaluations: action.sprintEvaluations
            }
        case "GET_SPRINT_GRADES":
            return {
                ...prevState,
                sprintGrades: action.sprintGrades
            }
        case "SET_TEACHER_CLASSES_AND_CLASS":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                classObject: action.classObject,
                possibleClasses: action.possibleClasses
            }
        case "GET_STUDENT_REVIEWING_EVALUATIONS":
            return {
                ...prevState,
                reviewingEvaluations: action.reviewingEvaluations
            }
        case "EDIT_STUDENT_REVIEWING_EVALUATIONS":
            return {
                ...prevState,
                reviewingEvaluations: action.reviewingEvaluations,
                authErrCode: {
                    ...prevState.authErrCode,
                    editEvals: {status: 201}
                }
            }
        case "GET_SPRINTS_AND_TEACHER_CLASSES":
            return {
                ...prevState,
                sprints: action.sprints,
                teacherClasses: action.teacherClasses
            }
        case "GET_STUDENT_REVIEWED_EVALUATIONS":
            return {
                ...prevState,
                reviewedEvaluations: action.reviewedEvaluations
            }
        case "GET_TEACHER_EVALUATIONS":
            return {
                ...prevState,
                teacherEvaluations: action.teacherEvaluations,
                loadingAssets: {
                    ...prevState.loadingAssets,
                    gradingEvaluations: false
                }
            }
        case "GET_TEACHER_EVALUATIONS_PAGINATED":
            return {
                ...prevState,
                teacherEvaluations: action.teacherEvaluations,
                numOfPages: action.numOfPages,
                loadingAssets: {
                    ...prevState.loadingAssets,
                    gradingEvaluations: false
                }
            }
        case "GET_TEACHER_EVALUATIONS_AND_ASSIGNMENTS":
            return {
                ...prevState,
                teacherEvaluations: action.teacherEvaluations,
                assignments: action.assignments
            }
        case "GET_TEACHER_STUDENTS":
            return {
                ...prevState,
                teacherStudents: action.teacherStudents
            }
        case "GET_TEACHER_STUDENTS_AND_EVALUATIONS":
            return {
                ...prevState,
                teacherStudents: action.teacherStudents,
                teacherEvaluations: action.teacherEvaluations
            }
        case "GET_USER_AND_TEACHER_POSSIBLE_CLASSES":
            return {
                ...prevState,
                teacherClasses: action.teacherClasses,
                possibleClasses: action.possibleClasses,
                user: action.user
            }
        case "SET_EVALUATION_SPRINT_AND_ASSIGNMENT":{
            console.log('SET_EVALUATION_SPRINT_AND_ASSIGNMENT:',action.sprint)
            return {
                ...prevState,
                assignment: action.assignment,
                evaluation: action.evaluation,
                sprint: action.sprint
            }}
        case "LOADING_ASSETS":
            return {
                ...prevState,
                loadingAssets: {
                    ...prevState.loadingAssets,
                    [action.loadingAssets]: true
                }
            }
        case "SIGNUP_SUCCESS":
            return {
                ...prevState,
                isAuthenticated: true,
                user: action.user
            }
        case "GET_SERVER_TIME":
            return {
                ...prevState,
                serverTimeAsUtcISO: action.serverTimeAsUtcISO
            }
        default:
            return prevState
    }
}
